import { createContext, useContext, useState, useCallback } from "react";
import AppToast from "../components/AppToast";

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const showToast = useCallback((type, title, message) => {
    setToast({ type, title, message });
  }, []);

  const closeToast = () => setToast(null);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <AppToast toast={toast} onClose={closeToast} />
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);